export const translationOpenDrawer = {
  ar: {
    search: "بحث",
    clear: "مسح",
    categories: "الفئات",
    subCategories: "الفئات الفرعية",
    order: "",
    "ascending A-Z": "تصاعدي A-Z",
    "descending Z-A": "تنازلي Z-A",
    selectCategory: "اختر الفئة",
  },
  cz: {
    search: "Hledat",
    clear: "Vyčistit",
    categories: "Kategorie",
    subCategories: "Podkategorie",
    order: "",
    "ascending A-Z": "Vzestupně A-Z",
    "descending Z-A": "Sestupně Z-A",
    selectCategory: "Vyberte kategorii",
  },
  en: {
    search: "Search",
    clear: "Clear",
    categories: "Categories",
    subCategories: "Subcategories",
    order: "",
    "ascending A-Z": "Ascending A-Z",
    "descending Z-A": "Descending Z-A",
    selectCategory: "Select category",
  },
  de: {
    search: "Suchen",
    clear: "Leeren",
    categories: "Kategorien",
    subCategories: "Unterkategorien",
    order: "",
    "ascending A-Z": "Aufsteigend A-Z",
    "descending Z-A": "Absteigend Z-A",
    selectCategory: "Kategorie auswählen",
  },
  es: {
    search: "Buscar",
    clear: "Limpiar",
    categories: "Categorías",
    subCategories: "Subcategorías",
    order: "",
    "ascending A-Z": "Ascendente A-Z",
    "descending Z-A": "Descendente Z-A",
    selectCategory: "Seleccionar categoría",
  },
  fr: {
    search: "Rechercher",
    clear: "Effacer",
    categories: "Catégories",
    subCategories: "Sous-catégories",
    order: "",
    "ascending A-Z": "Croissant A-Z",
    "descending Z-A": "Décroissant Z-A",
    selectCategory: "Sélectionner la catégorie",
  },
  hu: {
    search: "Keresés",
    clear: "Töröl",
    categories: "Kategóriák",
    subCategories: "Alkategóriák",
    order: "",
    "ascending A-Z": "Növekvő A-Z",
    "descending Z-A": "Csökkenő Z-A",
    selectCategory: "Kiválasztott kategóriá kiválasztása",
  },
  nl: {
    search: "Zoeken",
    clear: "Wissen",
    categories: "Categorieën",
    subCategories: "Subcategorien",
    order: "",
    "ascending A-Z": "Oplopend A-Z",
    "descending Z-A": "Aflopend Z-A",
    selectCategory: "Selecteer categorie",
  },
  pl: {
    search: "Szukaj",
    clear: "Wyczyść",
    categories: "Kategorie",
    subCategories: "Podkategorie",
    order: "",
    "ascending A-Z": "Rosnąco A-Z",
    "descending Z-A": "Malejąco Z-A",
    selectCategory: "Wybierz kategorie",
  },
  ru: {
    search: "Поиск",
    clear: "Очистить",
    categories: "Категории",
    subCategories: "Подкатегории",
    order: "",
    "ascending A-Z": "По возрастанию A-Я",
    "descending Z-A": "По убыванию Я-А",
    selectCategory: "Выберите категорию",
  },
  sk: {
    search: "Hľadať",
    clear: "Vymazať",
    categories: "Kategórie",
    subCategories: "Podkategórie",
    order: "",
    "ascending A-Z": "Vzostupne A-Z",
    "descending Z-A": "Zostupne Z-A",
    selectCategory: "Zvoľte kategóriu",
  },
  sv: {
    search: "Sök",
    clear: "Rensa",
    categories: "Kategorier",
    subCategories: "Underkategorier",
    order: "",
    "ascending A-Z": "Stigande A-Z",
    "descending Z-A": "Fallande Z-A",
    selectCategory: "Välj kategori",
  },
  no: {
    search: "Søk",
    clear: "Tøm",
    categories: "Kategorier",
    subCategories: "Underkategorier",
    order: "",
    "ascending A-Z": "Stigende A-Z",
    "descending Z-A": "Synkende Z-A",
    selectCategory: "Velg kategori",
  },
  da: {
    search: "Søg",
    clear: "Ryd",
    categories: "Kategorier",
    subCategories: "Underkategorier",
    order: "",
    "ascending A-Z": "Stigende A-Z",
    "descending Z-A": "Faldende Z-A",
    selectCategory: "Vælg kategori",
  },
  fi: {
    search: "Hae",
    clear: "Tyhjennä",
    categories: "Kategoriat",
    subCategories: "Alakategoriat",
    order: "",
    "ascending A-Z": "Nouseva A-Z",
    "descending Z-A": "Laskeva Z-A",
    selectCategory: "Valitse kategoria",
  },
};

export default translationOpenDrawer;
